document.addEventListener("DOMContentLoaded", () => {
  reportHeight();
  const resizeObserver = new ResizeObserver(() => reportHeight());
  resizeObserver.observe(document.documentElement);
});

// Report internal height, so that our resizer script can use it
// See public/static/resizer.js for the other side of the equation
function reportHeight() {
  // the html element is usually slightly bigger than the body, so we pad this vaue
  const height = document.body.scrollHeight + 10;
  const message = { type: "report-height", value: { height } };
  window.top.postMessage(message, "*");
}
